import React from 'react';
import Select, { OptionTypeBase } from 'react-select';
import { useTheme } from 'styled-components';

type TProps = {
    offerCode?: string;
    selected: number;
    max?: number;
    handleQtyChange: (option: OptionTypeBase, offerCode?: string) => void;
    disabled?: boolean;
};

const QuantitySelector = ({ disabled, handleQtyChange, max = 1, offerCode, selected }: TProps): JSX.Element => {
    const theme = useTheme(); // #TODO: @Nipun - this should be implied
    const quantity = selected;
    const changeQty: any = handleQtyChange;

    const getOptions = (): OptionTypeBase[] =>
        new Array(max).fill(null).map((_, i) => ({ label: i + 1, value: i + 1 }));
    const options = getOptions();
    const value: OptionTypeBase = { label: quantity, value: quantity };

    // STYLES
    const customStyles = {
        control: (_: Record<string, unknown>, { isDisabled }: { isDisabled: boolean }): Record<string, unknown> =>
            ({
                width: '104px',
                height: '48px',
                borderRadius: '24px',
                cursor: isDisabled ? 'not-allowed' : 'pointer',
                display: 'flex',
                backgroundColor: isDisabled ? theme.colors.bgTertiary : theme.colors.bgSecondary,
                opacity: isDisabled ? 0.8 : 1,
            } as Partial<Record<string, unknown>>),
        valueContainer: (): Record<string, unknown> =>
            ({
                flex: 1,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                paddingLeft: '12px',
            } as Partial<Record<string, unknown>>),
        singleValue: (): Record<string, unknown> =>
            ({
                fontWeight: 'bold',
            } as Partial<Record<string, unknown>>),
        indicatorsContainer: (): Record<string, unknown> => ({
            border: `2px solid`,
            color: theme.colors.brandPrimary,
            borderRadius: '24px',
            width: '48px',
            height: '48px',
            backgroundColor: theme.colors.bodyAlt,
            display: 'flex',
        }),
        indicatorSeparator: (): Record<string, unknown> =>
            ({
                display: 'none',
            } as Partial<Record<string, unknown>>),
        dropdownIndicator: (): Record<string, unknown> => ({
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'transform ease-in-out 0.2s',

            '&:hover': {
                transform: 'scale(1.25)',
            },
        }),
        menu: (provided: Record<string, unknown>): Record<string, unknown> =>
            ({
                ...provided,
                boxShadow: '0 6px 34px rgba(0,0,0,0.11)',
            } as Partial<Record<string, unknown>>),
        menuList: (provided: Record<string, unknown>): Record<string, unknown> =>
            ({
                ...provided,
                padding: '8px',
            } as Partial<Record<string, unknown>>),
        option: (provided: Record<string, unknown>, state: Record<string, unknown>): Record<string, unknown> =>
            ({
                ...provided,
                padding: '12px 40px 12px 4px',
                cursor: 'pointer',
                textAlign: 'center',
                borderRadius: theme.metrics.borderRadius,
                fontWeight: '600',
                backgroundColor: state.isSelected ? theme.colors.brandPrimary : '',

                '&:hover': {
                    backgroundColor: state.isSelected ? theme.colors.brandPrimary : theme.colors.brandPrimaryLight,
                },
            } as Partial<Record<string, unknown>>),
    };
    return (
        <Select
            value={value}
            options={options}
            isSearchable={false}
            isDisabled={disabled}
            onChange={e => changeQty(e, offerCode)}
            styles={customStyles}
            menuPortalTarget={document.querySelector('body')}
        />
    );
};

export default QuantitySelector;
